import { Suspense, lazy, ElementType } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import MainLayout from '../layouts/main';
// import DashboardLayout from '../layouts/dashboard';
// import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
// guards
// import GuestGuard from '../guards/GuestGuard';
// import AuthGuard from '../guards/AuthGuard';
// import RoleBasedGuard from '../guards/RoleBasedGuard';
// config
// import { PATH_AFTER_LOGIN } from '../config';
// components
import LoadingScreen from '../components/LoadingScreen';
// import { authState } from '../recoil/atom/auth/authState';
// import { useRecoilValue } from 'recoil';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  // const { pathname } = useLocation();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  // const isAuthenticated = useRecoilValue(authState);

  // const isDashboard = pathname.includes('/app') && isAuthenticated;

  return (
    <Suspense fallback={<LoadingScreen isDashboard={true} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    // {
    //   path: 'auth',
    //   children: [
    //     {
    //       path: 'login',
    //       element: (
    //         <GuestGuard>
    //           <Login />
    //         </GuestGuard>
    //       ),
    //     },
    //     {
    //       path: 'register',
    //       element: (
    //         <GuestGuard>
    //           <Register />
    //         </GuestGuard>
    //       ),
    //     },
    //     { path: 'login-unprotected', element: <Login /> },
    //     { path: 'register-unprotected', element: <Register /> },
    //     { path: 'forget-password', element: <ResetPassword /> },
    //     { path: 'verify-code/:type', element: <VerifyCode /> },
    //     { path: 'setting-password/:type', element: <SettingPassword /> },
    //   ],
    // },

    // Dashboard Routes
    // {
    //   path: 'app',
    //   element: (
    //     <AuthGuard>
    //       <DashboardLayout />
    //     </AuthGuard>
    //   ),
    //   children: [
    //     // { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
    //     // { path: '/', element: <ProjectList />, index: true },
    //     { path: '', element: <ProjectList /> },
    //   ],
    // },
    // {
    //   path: 'main',
    //   element: (
    //     // <AuthGuard>
    //     <LogoOnlyLayout />
    //     // </AuthGuard>
    //   ),
    //   children: [
    //     // { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
    //     // { path: '/', element: <ProjectList />, index: true },
    //     {
    //       path: 'account',
    //       element: <CreateAccount />,
    //     },
    //   ],
    // },

    // Main Routes
    // {
    //   path: '*',
    //   element: <LogoOnlyLayout />,
    //   children: [
    //     { path: 'coming-soon', element: <ComingSoon /> },
    //     { path: 'maintenance', element: <Maintenance /> },
    //     { path: 'pricing', element: <Pricing /> },
    //     { path: 'payment', element: <Payment /> },
    //     { path: '500', element: <Page500 /> },
    //     { path: '404', element: <Page404 /> },
    //     { path: '403', element: <Page403 /> },
    //     { path: '*', element: <Navigate to='/404' replace /> },
    //   ],
    // },
    {
      path: '/',
      element: <MainLayout />,
      children: [
        { element: <SplashScreen />, index: true },
        // { element: <TermAndCondition />, index: true },
        { path: 'term-and-condition', element: <TermAndCondition /> },
        { path: 'verify-mobile', element: <VerifyMobile /> },
        { path: 'otp', element: <OTP /> },
        { path: 'register', element: <Register /> },
        { path: 'home', element: <Home /> },
        { path: 'bill', element: <Bill /> },
        { path: 'qr-payment', element: <QRPayment /> },
        { path: 'statistic', element: <Statistic /> },
        { path: 'complain', element: <Complain /> },
        { path: 'power-outage', element: <PowerOutage /> },
        { path: 'news-message', element: <NewsMessage /> },
        { path: 'reciept-pdf', element: <DownloadReceiptPdf /> },
        { path: 'welfare-register', element: <WelfareRegister /> },
        // { path: 'contact-us', element: <Contact /> },
        // { path: 'faqs', element: <Faqs /> },
      ],
    },
    { path: '*', element: <Navigate to='/404' replace /> },
  ]);
}

// AUTHENTICATION
// const Login = Loadable(lazy(() => import('../pages/auth/Login')));
// const Demo = Loadable(lazy(() => import('../pages/Demo')));
const SplashScreen = Loadable(lazy(() => import('../pages/SplashScreen')));
const Register = Loadable(lazy(() => import('../pages/Register')));
const Complain = Loadable(lazy(() => import('../pages/Complain')));
const PowerOutage = Loadable(lazy(() => import('../pages/PowerOutage')));
const TermAndCondition = Loadable(lazy(() => import('../pages/TermAndCondition')));
const NewsMessage = Loadable(lazy(() => import('../pages/NewsMessage')));
const Home = Loadable(lazy(() => import('../pages/Home')));
const Bill = Loadable(lazy(() => import('../pages/Bill')));
const QRPayment = Loadable(lazy(() => import('../pages/QRPayment')));
const Statistic = Loadable(lazy(() => import('../pages/Statistic')));
const VerifyMobile = Loadable(lazy(() => import('../pages/VerifyMobile')));
const OTP = Loadable(lazy(() => import('../pages/OTP')));
const DownloadReceiptPdf = Loadable(lazy(() => import('../pages/DownloadReceiptPdf')));
const WelfareRegister = Loadable(lazy(() => import('../pages/WelfareRegister')));
